//
// 入社手続き（F-NEW-03 / 04 / 09）
//
// 招待メールのURL（/#/onboarding?token=...）から開く、ログイン前の画面。
// 書類の提出・情報入力・労働条件通知書の承諾をスマホ縦画面で行う。
// 手続き完了後は閲覧のみ（提出・入力のフォームは出さない。前回のURLでの提出は反映されない）。
//
const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf']
const MAX_FILE_SIZE = 10 * 1024 * 1024
const MAX_FILES = 10
// 住民票は提出前に「個人番号の記載はありませんか？」を確認する
const RESIDENCE_DOCUMENT_TYPE = 'residence'

export default {
  name: 'onboarding',
  created () {
    this.search()
  },
  data () {
    return {
      callbackFlag: false,
      files: {},
      previews: {},
      errors: {},
      // 免許証・任意保険証・車検証の有効期限（document_type → yyyy-mm-dd）
      expiryDates: {},
      submitting: null,
      // 「なし」申告の登録・取消中の書類種別
      notApplicableSubmitting: null,
      // 住民票の提出前確認（個人番号の記載はありませんか？）
      residenceConfirmVisible: false,
      savingProfile: false,
      // 本人情報が保存できなかったときの文言（保存ボタンの近くに出す）
      profileError: null,
      consenting: false,
      profile: {
        user_name: '',
        user_firstname: '',
        user_name_furigana: '',
        user_firstname_furigana: '',
        user_birthday: '',
        user_sex: '',
        join_id: '',
        user_post_no: '',
        user_address: '',
        user_mobile: '',
        emergency_contact_name: '',
        emergency_contact_relation: '',
        emergency_contact_tel: '',
        emergency_contact2_name: '',
        emergency_contact2_relation: '',
        emergency_contact2_tel: '',
        bank_name: '',
        bank_branch_name: '',
        bank_account_type: '1',
        bank_account_number: '',
        bank_account_holder: '',
        my_number: '',
        // 通勤手段・配偶者・扶養・兼業・職歴・備考・確認チェック（r643 / r665-682。総務用名簿に印字する）
        commute_method: '',
        commute_public_detail: '',
        is_dormitory: false,
        has_spouse: '',
        has_dependents: '',
        dependents_count: '',
        has_side_job: '',
        side_job_started_on: '',
        work_history1_from: '',
        work_history1_to: '',
        work_history1_content: '',
        work_history2_from: '',
        work_history2_to: '',
        work_history2_content: '',
        work_history3_from: '',
        work_history3_to: '',
        work_history3_content: '',
        profile_remarks: '',
        profile_confirmed: false
      }
    }
  },
  computed: {
    token () {
      return this.$route.query.token
    },
    user () {
      return this.$store.getters.onboardingUser
    },
    documents () {
      return this.$store.getters.onboardingDocuments || []
    },
    contract () {
      return this.$store.getters.onboardingContract
    },
    // 入社経緯の選択肢（社員編集画面と同じマスタ・並び）
    joins () {
      return this.$store.getters.onboardingJoins || []
    },
    // 手続きの進捗（会社側の本登録チェックと同じ項目・判定。ready / ok / total / items。r268）
    progress () {
      return this.$store.getters.onboardingProgress
    },
    // 職歴の行番号（1〜3。users.work_history1〜3_*）
    workHistoryRows () {
      return [1, 2, 3]
    },
    // 仮登録（まだ書類の提出・本人情報の保存が無い）
    isTemporary () {
      return !!this.user && this.user.onboarding_status === 'onboarding_temporary'
    },
    message () {
      return this.$store.getters.onboardingMessage
    },
    error () {
      return this.$store.getters.onboardingError
    },
    invalidToken () {
      return this.$store.getters.onboardingInvalidToken || !this.token
    },
    // 手続き完了後は提出・入力のフォームを出さない
    isCompleted () {
      return !!this.user && this.user.onboarding_status === 'onboarding_completed'
    },
    // 確認中（提出済みの書類がすべて承認され、店舗の本登録待ち。No18）。提出・入力はこれまでどおりできる
    isReviewing () {
      return !!this.user && this.user.onboarding_status === 'onboarding_reviewing'
    },
    contractUrl () {
      return this.$store.state.config.api_method + '://' + this.$store.state.config.api_server + '/' +
        this.$store.state.config.api_version + '/asovi/onboarding/contracts/notice?token=' + this.token
    }
  },
  methods: {
    search: function () {
      if (!this.token) {
        this.callbackFlag = true
        return
      }
      var self = this
      var callback = function () {
        self.callbackFlag = true
        self.fillProfile()
      }
      this.$store.dispatch('GET_ONBOARDING_ME', {token: this.token, callback: callback})
    },
    // 入力済みの内容を画面に反映する
    fillProfile: function () {
      if (!this.user) {
        return
      }
      var keys = ['user_name', 'user_firstname', 'user_name_furigana', 'user_firstname_furigana',
        'user_birthday', 'user_post_no', 'user_address', 'user_mobile',
        'emergency_contact_name', 'emergency_contact_relation', 'emergency_contact_tel',
        'emergency_contact2_name', 'emergency_contact2_relation', 'emergency_contact2_tel',
        'bank_name', 'bank_branch_name', 'bank_account_holder',
        'commute_method', 'commute_public_detail', 'side_job_started_on', 'profile_remarks']
      for (var i = 0; i < keys.length; i++) {
        if (this.user[keys[i]]) {
          this.profile[keys[i]] = this.user[keys[i]]
        }
      }
      if (this.user.user_sex) {
        this.profile.user_sex = String(this.user.user_sex)
      }
      if (this.user.join_id) {
        this.profile.join_id = String(this.user.join_id)
      }
      if (this.user.bank_account_type) {
        this.profile.bank_account_type = String(this.user.bank_account_type)
      }
      // 有／無（1 / 0。未入力は null → ''）・入寮・扶養人数・職歴3行。確認チェックは保存済みなら入れたままにする
      var yesNoKeys = ['has_spouse', 'has_dependents', 'has_side_job']
      for (var j = 0; j < yesNoKeys.length; j++) {
        var value = this.user[yesNoKeys[j]]
        this.profile[yesNoKeys[j]] = (value === null || value === undefined) ? '' : String(value)
      }
      this.profile.is_dormitory = this.user.is_dormitory === 1
      this.profile.dependents_count = this.user.dependents_count ? String(this.user.dependents_count) : ''
      var histories = this.user.work_histories || []
      for (var k = 0; k < histories.length && k < 3; k++) {
        var row = k + 1
        this.profile['work_history' + row + '_from'] = histories[k].from || ''
        this.profile['work_history' + row + '_to'] = histories[k].to || ''
        this.profile['work_history' + row + '_content'] = histories[k].content || ''
      }
      this.profile.profile_confirmed = !!this.user.profile_confirmed_at_format
    },
    // 通勤手段・配偶者・扶養・兼業・職歴・備考のいずれかに入力があるか（あれば確認チェックが必要。API でも同じ判定）
    hasPersonalProfileInput: function () {
      var p = this.profile
      if (p.commute_method || p.is_dormitory || p.has_spouse !== '' || p.has_dependents !== '' || p.has_side_job !== '' || p.profile_remarks) {
        return true
      }
      for (var row = 1; row <= 3; row++) {
        if (p['work_history' + row + '_from'] || p['work_history' + row + '_to'] || p['work_history' + row + '_content']) {
          return true
        }
      }
      return false
    },
    // 郵便番号（ハイフン無し7桁）が揃ったら住所を自動入力する（取得できなければ何もしない）
    onChangePostNo: function () {
      var postNo = (this.profile.user_post_no || '').replace(/-/g, '')
      if (!/^[0-9]{7}$/.test(postNo)) {
        return
      }
      var self = this
      this.$store.dispatch('SEARCH_ONBOARDING_ADDRESS', {
        zipcode: postNo,
        callback: function (address) {
          // 取得後に郵便番号が変わっていたら反映しない
          if ((self.profile.user_post_no || '').replace(/-/g, '') === postNo) {
            self.profile.user_address = address
          }
        }
      })
    },
    // 書類種別ごとの file input（v-for 内の ref は配列になる。「なし」申告中の書類は input を出さないため、
    // 配列の添字ではなく書類種別で引く）
    fileInputFor: function (prefix, documentType) {
      var refs = this.$refs[prefix + '_' + documentType]
      if (!refs) {
        return null
      }
      return Array.isArray(refs) ? refs[0] : refs
    },
    openCamera: function (documentType) {
      var input = this.fileInputFor('cameraInput', documentType)
      if (input) {
        input.value = ''
        input.click()
      }
    },
    openFile: function (documentType) {
      var input = this.fileInputFor('fileInput', documentType)
      if (input) {
        input.value = ''
        input.click()
      }
    },
    // 選択済みのファイル（配列）
    selectedFiles: function (documentType) {
      return this.files[documentType] || []
    },
    // 住民票は「貼付」、それ以外は「提出」と表記する
    submitLabel: function (item) {
      var count = this.selectedFiles(item.document_type).length
      return count + '枚' + (item.document_type === RESIDENCE_DOCUMENT_TYPE ? '貼付する' : '提出する')
    },
    // 選択された全ファイルを検証し、既存の選択に追記する（撮り直しを積み上げられるようにする）
    onFileChange: function (documentType, event) {
      var selected = event.target.files || event.dataTransfer.files
      if (!selected || selected.length === 0) {
        return
      }
      var files = (this.files[documentType] || []).slice()
      var previews = (this.previews[documentType] || []).slice()
      var messages = []

      for (var i = 0; i < selected.length; i++) {
        var file = selected[i]
        var extension = (file.name || '').split('.').pop().toLowerCase()
        if (files.length >= MAX_FILES) {
          messages.push('一度に提出できるのは' + MAX_FILES + '枚までです。')
          break
        }
        if (ALLOWED_EXTENSIONS.indexOf(extension) < 0) {
          messages.push(file.name + ' は jpg / jpeg / png / pdf ではありません。')
          continue
        }
        if (file.size > MAX_FILE_SIZE) {
          messages.push(file.name + ' はファイルサイズが10MBを超えています。')
          continue
        }
        files.push(file)
        previews.push(null)
        if (extension !== 'pdf') {
          this.readPreview(documentType, file, files.length - 1)
        }
      }

      this.$set(this.files, documentType, files)
      this.$set(this.previews, documentType, previews)
      this.$set(this.errors, documentType, messages.length > 0 ? messages.join(' ') : null)
    },
    // 画像のサムネイルを非同期に読み込む
    readPreview: function (documentType, file, index) {
      var self = this
      var reader = new FileReader()
      reader.onload = (e) => {
        var previews = (self.previews[documentType] || []).slice()
        previews[index] = e.target.result
        self.$set(self.previews, documentType, previews)
      }
      reader.readAsDataURL(file)
    },
    // 選択したファイルを1枚だけ取り消す
    removeFile: function (documentType, index) {
      var files = (this.files[documentType] || []).slice()
      var previews = (this.previews[documentType] || []).slice()
      files.splice(index, 1)
      previews.splice(index, 1)
      this.$set(this.files, documentType, files)
      this.$set(this.previews, documentType, previews)
      this.$set(this.errors, documentType, null)
    },
    // 選択中のファイルをすべて取り消す（住民票の確認で【いいえ】を選んだとき）
    clearFiles: function (documentType) {
      this.$set(this.files, documentType, [])
      this.$set(this.previews, documentType, [])
      this.$set(this.errors, documentType, null)
    },
    // 有効期限の入力が必要な書類か（免許証・任意保険証・車検証）
    requiresExpiryDate: function (item) {
      return !!item.requires_expiry_date
    },
    // 手続きの進捗で、本登録の必須でない項目か（免許証・任意保険証・車検証。API の progress.items[].required が false）
    // 旧 API（required が無い）では必須扱い
    isOptionalItem: function (item) {
      return item.required === false
    },
    // 有効な提出（最新回次が差戻しでない＝提出済・承認）があるか。あれば【なし】は押せない
    hasValidSubmission: function (item) {
      var submissions = item.submissions || []
      return submissions.length > 0 && submissions[0].status !== 'rejected'
    },
    submitDocument: function (item) {
      var documentType = item.document_type
      var files = this.files[documentType] || []
      if (files.length === 0 || this.submitting) {
        return
      }
      if (this.requiresExpiryDate(item) && !this.expiryDates[documentType]) {
        this.$set(this.errors, documentType, '有効期限を入力してください。')
        return
      }
      this.$set(this.errors, documentType, null)
      // 住民票は個人番号の記載が無いことを確認してから提出する（はい/いいえ の画面内モーダル）
      if (documentType === RESIDENCE_DOCUMENT_TYPE) {
        this.residenceConfirmVisible = true
        return
      }
      if (!window.confirm('この内容で' + files.length + '枚提出します。よろしいですか？')) {
        return
      }
      this.doSubmitDocument(documentType)
    },
    // 住民票の確認【はい】: 提出する
    confirmResidenceYes: function () {
      this.residenceConfirmVisible = false
      this.doSubmitDocument(RESIDENCE_DOCUMENT_TYPE)
    },
    // 住民票の確認【いいえ】: 選択中のファイルを消してやり直す
    confirmResidenceNo: function () {
      this.residenceConfirmVisible = false
      this.clearFiles(RESIDENCE_DOCUMENT_TYPE)
    },
    doSubmitDocument: function (documentType) {
      var files = this.files[documentType] || []
      if (files.length === 0 || this.submitting) {
        return
      }
      var self = this
      var count = files.length
      this.submitting = documentType

      var formData = new FormData()
      formData.append('document_type', documentType)
      if (this.expiryDates[documentType]) {
        formData.append('expiry_date', this.expiryDates[documentType])
      }
      for (var i = 0; i < files.length; i++) {
        formData.append('files[]', files[i])
      }

      var callback = function () {
        self.submitting = null
        self.$set(self.files, documentType, [])
        self.$set(self.previews, documentType, [])
        self.$set(self.expiryDates, documentType, '')
        window.alert(count + '枚提出しました。担当者の確認をお待ちください。')
        self.search()
      }
      var errorCallback = function (message) {
        self.submitting = null
        self.$set(self.errors, documentType, message || '提出に失敗しました。')
      }
      this.$store.dispatch('CREATE_ONBOARDING_DOCUMENT', {
        token: this.token, data: formData, callback: callback, errorCallback: errorCallback
      })
    },
    // 【なし】: その書類を持っていないことを申告する
    markNotApplicable: function (item) {
      if (this.notApplicableSubmitting || this.hasValidSubmission(item)) {
        return
      }
      if (!window.confirm(item.document_type_i18n + 'を「なし」として登録します。よろしいですか？')) {
        return
      }
      var self = this
      var documentType = item.document_type
      this.notApplicableSubmitting = documentType
      this.clearFiles(documentType)
      this.$store.dispatch('CREATE_ONBOARDING_NOT_APPLICABLE', {
        token: this.token,
        documentType: documentType,
        callback: function () {
          self.notApplicableSubmitting = null
          self.search()
        }
      })
      .then(() => { self.notApplicableSubmitting = null })
      .catch(() => { self.notApplicableSubmitting = null })
    },
    // 【取消】: 「なし」の申告を取り消して提出できる状態に戻す
    cancelNotApplicable: function (item) {
      if (this.notApplicableSubmitting) {
        return
      }
      var self = this
      var documentType = item.document_type
      this.notApplicableSubmitting = documentType
      this.$store.dispatch('DESTROY_ONBOARDING_NOT_APPLICABLE', {
        token: this.token,
        documentType: documentType,
        callback: function () {
          self.notApplicableSubmitting = null
          self.search()
        }
      })
      .then(() => { self.notApplicableSubmitting = null })
      .catch(() => { self.notApplicableSubmitting = null })
    },
    saveProfile: function () {
      if (this.savingProfile) {
        return
      }
      // 必須（API でも同じ検証をする）: 氏名・ふりがな・生年月日・性別・入社経緯・緊急連絡先1
      if (!this.profile.user_name || !this.profile.user_firstname ||
          !this.profile.user_name_furigana || !this.profile.user_firstname_furigana) {
        window.alert('氏名とふりがなを入力してください。')
        return
      }
      if (!this.profile.user_birthday || !this.profile.user_sex) {
        window.alert('生年月日と性別を入力してください。')
        return
      }
      if (!this.profile.join_id) {
        window.alert('入社経緯を選択してください。')
        return
      }
      if (!this.profile.emergency_contact_name || !this.profile.emergency_contact_relation || !this.profile.emergency_contact_tel) {
        window.alert('緊急連絡先1（氏名・続柄・電話番号）をすべて入力してください。')
        return
      }
      // 通勤手段・配偶者・扶養・兼業・職歴・備考（本登録の条件ではないが、入れるときは条件付きの項目と確認チェックが必要。API でも同じ検証をする）
      if (this.profile.commute_method === 'public_transport' && !this.profile.commute_public_detail) {
        window.alert('通勤手段が公共機関の場合は、公共機関の内容を入力してください。')
        return
      }
      if (this.profile.has_dependents === '1' && !(parseInt(this.profile.dependents_count, 10) >= 1)) {
        window.alert('扶養義務が有の場合は、扶養人数を1以上の数字で入力してください。')
        return
      }
      if (this.profile.has_side_job === '1' && !this.profile.side_job_started_on) {
        window.alert('兼業が有の場合は、他社就職年月を入力してください。')
        return
      }
      if (this.hasPersonalProfileInput() && !this.profile.profile_confirmed) {
        window.alert('通勤手段・配偶者・扶養義務・兼業・職歴・備考を保存するには「上記の内容に相違がないことを確認しました」にチェックしてください。')
        return
      }
      var self = this
      this.savingProfile = true
      this.profileError = null
      var callback = function () {
        self.savingProfile = false
        self.profile.bank_account_number = ''
        self.profile.my_number = ''
        window.alert('入力内容を保存しました。')
        self.search()
      }
      // 保存できなかったとき（形式エラーなど）は保存ボタンの近くに文言を出す
      // （画面上部の表示だけでは気付かず、保存できたと思い込んで仮登録のままになるため。r268）
      var errorCallback = function (message) {
        self.savingProfile = false
        self.profileError = message || '保存に失敗しました。'
      }
      this.$store.dispatch('UPDATE_ONBOARDING_PROFILE', {
        token: this.token, data: this.profile, callback: callback, errorCallback: errorCallback
      })
      .then(() => { self.savingProfile = false })
      .catch(() => { self.savingProfile = false })
    },
    consent: function () {
      if (this.consenting) {
        return
      }
      if (!window.confirm('労働条件通知書の内容に同意して承諾します。よろしいですか？')) {
        return
      }
      var self = this
      this.consenting = true
      var callback = function () {
        self.consenting = false
        window.alert('承諾しました。')
        self.search()
      }
      this.$store.dispatch('CONSENT_ONBOARDING_CONTRACT', {token: this.token, callback: callback})
      .then(() => { self.consenting = false })
      .catch(() => { self.consenting = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/onboarding.js